var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 18.3333C0.333496 16.5651 1.03588 14.8694 2.28612 13.6192C3.53636 12.369 5.23205 11.6666 7.00016 11.6666C8.76827 11.6666 10.464 12.369 11.7142 13.6192C12.9644 14.8694 13.6668 16.5651 13.6668 18.3333H12.0002C12.0002 17.0072 11.4734 15.7354 10.5357 14.7977C9.59801 13.86 8.32624 13.3333 7.00016 13.3333C5.67408 13.3333 4.40231 13.86 3.46463 14.7977C2.52695 15.7354 2.00016 17.0072 2.00016 18.3333H0.333496ZM7.00016 10.8333C4.23766 10.8333 2.00016 8.59575 2.00016 5.83325C2.00016 3.07075 4.23766 0.833252 7.00016 0.833252C9.76266 0.833252 12.0002 3.07075 12.0002 5.83325C12.0002 8.59575 9.76266 10.8333 7.00016 10.8333ZM7.00016 9.16658C8.84183 9.16658 10.3335 7.67492 10.3335 5.83325C10.3335 3.99159 8.84183 2.49992 7.00016 2.49992C5.1585 2.49992 3.66683 3.99159 3.66683 5.83325C3.66683 7.67492 5.1585 9.16658 7.00016 9.16658Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.1c806ff0a21bbc92063ef48778b1345f.svg";
export { ForwardRef as ReactComponent };